module.exports = "https://bin.bnbstatic.com/_next/static/images/chz-banner-en-78ad0a34ab1b87a4bb0ddae51dc22bd2.jpg";